// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customAvatraSelected[data-v-2a67057b]{\n  border-radius: 100px;\n  border: 0.5px solid rgba(36, 36, 36, 0.10);\n  background: #FFF;\n}\n.removePadding[data-v-2a67057b]{\n  margin-top: 0 !important;\n  padding: 4px !important;\n  margin-bottom: 4px !important;\n}\n", ""]);
// Exports
module.exports = exports;
